import { Component, Input } from '@angular/core';
import { BaseForm } from '@forms/base.form';
import { BenefitDivision } from '@app/models/benefits/benefit-division.model';
import { BenefitPlan } from '@models/benefits/benefit-plan.model';

@Component({
    selector: 'app-form-benefits-enrollment-settings',
    templateUrl: './employee-assignment.template.html',
})
export class BenefitsEnrollmentSettings extends BaseForm {
    @Input() benefitPlan: BenefitPlan;

    selectedBenefitDivision: BenefitDivision = null;
    waiveWaitingPeriod = false;
}
